var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<pkp-alert type=\"danger\" show-timestamp=\"true\" dismissible=\"true\">\n<strong> - An error occured while processing your request.</strong>\nPlease try again. If the error persists, please contact the support.\n</pkp-alert>\n";
var id1="app/includes/generalError.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;